<template>
  <ContentInfoLinks :links="links" />
</template>

<script>
import ContentInfoLinks from 'chimera/all/themes/blueflow/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      links: [
        {
          title: 'Algemeen',
          to: '/informatie-over-hoveniers/',
        },
        {
          title: 'Tuinontwerp',
          to: '/informatie-over-hoveniers/tuinontwerp',
        },
        {
          title: 'Tuinbestrating',
          to: '/informatie-over-hoveniers/tuinbestrating',
        },
        {
          title: 'Tuinonderhoud',
          to: '/informatie-over-hoveniers/tuinonderhoud',
        },
        {
          title: 'Tuinrenovatie',
          to: '/informatie-over-hoveniers/tuinrenovatie',
        },
      ],
    }
  },
}
</script>
